module.exports = __webpack_public_path__ + "img/center13.d834d719.png";